import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './cta-button.module.css';

interface CTAButtonProps {
    text: string;
    className?: string;
    href?: string;
    type?: 'button' | 'submit' | 'reset';
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    isLoading?: boolean;
}

const CTAButton: React.FC<CTAButtonProps> = ({
                                                 text,
                                                 className,
                                                 type = 'button',
                                                 href,
                                                 onClick,
                                                 disabled = false,
                                                 isLoading = false,
                                             }) => {
    const isExternal = href?.startsWith('http');

    return (
        <div className={styles.buttonWrapper}>
            {href ? (
                <a
                    href={href}
                    target={isExternal ? '_blank' : undefined}
                    rel={isExternal ? 'noopener noreferrer' : undefined}
                    className={`${styles.cta_button} ${className} btn btn-lg btn-primary`}
                >
                    {text}
                </a>
            ) : (
                <Button
                    className={`${styles.cta_button} ${className}`}
                    size="lg"
                    onClick={onClick}
                    disabled={disabled || isLoading}
                    type={type}
                >
                    {text}
                </Button>
            )}
        </div>
    );
};

export default CTAButton;
